export default {
  phone: 'input-field ng-intl-tel-input',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/fields.js